export default __webpack_public_path__ + "static/media/evals_icon.9d217610.svg";